import * as React from 'react';
import { Primary } from '../../misc';

export const PrimaryButton = ({
  name,
  iconClass,
  onClick,
}: {
  name: string;
  iconClass: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}): JSX.Element => (
  <Primary onClick={onClick}>
    {name} <i className={iconClass} />
  </Primary>
);
